import React, { Component, Fragment } from "react";
import "./PrivacyPage.scss";

const Paragraph = (props) => {
  return props.data.map((item, index) => (
    <p
      key={index}
      className="item-paragraph"
      dangerouslySetInnerHTML={{ __html: item }}
    ></p>
  ));
};

const List = (props) => {
  const isOrdered = !!props.data?.ordered;
  const listClass = `item-lists${isOrdered ? " ordered" : ""}`;
  return (
    <Fragment>
      {props.data?.title && (
        <p className="item-lists-title">{props.data.title}</p>
      )}
      <ol className={listClass}>
        {props.data.list.map((item, index) =>
          typeof item === "object" ? (
            item.map((v, i) => {
              switch (v.type) {
                case "paragraph":
                  return <Paragraph key={i} data={v.content} />;
                case "list":
                  return <List key={i} data={v.content} />;
                default:
                  return "";
              }
            })
          ) : (
            <li key={index} dangerouslySetInnerHTML={{ __html: item }}></li>
          )
        )}
      </ol>
    </Fragment>
  );
};

const Table = (props) => {
  const { useNo, columns, data } = props.data;

  return (
    <table className="item-table">
      <thead>
        <tr>
          {useNo && <th>No</th>}
          {columns.map((item, index) => (
            <th key={index}>{item.name}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) =>
          item.hasOwnProperty("isHeader") && item.isHeader ? (
            <tr key={`h-${index}`}>
              <th
                align={"center"}
                colSpan={item.config.colSpan + (useNo ? 1 : 0)}
              >
                {item.config.label}
              </th>
            </tr>
          ) : (
            <tr key={`r-${index}`}>
              {useNo && (
                <td className="index-no" align={"center"}>
                  {index}
                </td>
              )}
              {columns.map((value, key) => (
                <td key={key}>
                  {item.hasOwnProperty(value.key) ? item[value.key] : "-"}
                </td>
              ))}
            </tr>
          )
        )}
      </tbody>
    </table>
  );
};

const ContactBlock = () => (
  <div className="contact-block">
    <p className="contact-heading">
      <strong>PT Waterfront Sekuritas Indonesia</strong>
    </p>
    <p className="contact-detail">
      Head Office
      <br />
      Sona Topas Tower Lt. 15A, Jl. Jendral Sudirman Kav. 26, RT.4/RW.2,
      Kuningan, Karet, Kecamatan Setiabudi, Kota Jakarta Selatan, Daerah Khusus
      Ibukota Jakarta 12920
    </p>

    <div className="contact-row">
      <img
        className="contact-icon"
        src="/assets/images/privacy/envelope.svg"
        alt="Email"
      />
      <a href="mailto:csr@waterfront.co.id">csr@waterfront.co.id</a>
    </div>
    <div className="contact-row">
      <img
        className="contact-icon"
        src="/assets/images/privacy/phone.svg"
        alt="Phone"
      />
      <span>+6221 250-6355</span>
    </div>
    <div className="contact-row">
      <img
        className="contact-icon"
        src="/assets/images/privacy/printer.svg"
        alt="Fax"
      />
      <span>+6221 250-6322</span>
    </div>
    <div className="contact-row">
      <img
        className="contact-icon"
        src="/assets/images/privacy/globe.svg"
        alt="Website"
      />
      <a
        href="https://www.waterfrontsekuritas.com"
        target="_blank"
        rel="noreferrer"
      >
        www.waterfrontsekuritas.com
      </a>
    </div>
  </div>
);

class PrivacyPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
      isTocOpen: false,
      header: {
        title: "Kebijakan Privasi Aplikasi Winvest",
        description: [
          // satu paragraf ringan — menyatu dengan body di bawahnya
          `Dokumen ini berlaku untuk aplikasi Winvest yang didistribusikan melalui Google Play dan Apple App Store, dan dioperasikan oleh PT. Waterfront Sekuritas Indonesia. Kebijakan ini mengatur pemrosesan data pada layanan yang diakses melalui aplikasi Winvest.`
        ],
        meta: [
          { label: "Nama Aplikasi", value: "Winvest" },
          { label: "Entitas Hukum/Developer", value: "PT. Waterfront Sekuritas Indonesia" },
          {
            label: "Ruang Lingkup",
            value:
              "Android (Google Play) dan iOS (Apple App Store), termasuk fitur trading/investasi, autentikasi, notifikasi, analitik, dan komponen pihak ketiga."
          },
          { label: "Tanggal Berlaku", value: "07 Sep 2025 (v1.3)" }
        ]
      },
      list: [
        {
          title: "Kebijakan Privasi",
          description: [
            // ⇩⇩⇩ PARAGRAF TAMBAHAN di paling atas (hanya MENAMBAHKAN, konten existing tetap)
            {
              type: "paragraph",
              content: [
                `<em>Kebijakan ini secara eksplisit berlaku untuk aplikasi <strong>Winvest</strong> pada platform Android (Google Play) dan iOS (Apple App Store) yang dioperasikan oleh PT. Waterfront Sekuritas Indonesia.</em>`,
              ],
            },
            // === mulai konten ASLI (tidak diubah) ===
            {
              type: "paragraph",
              content: [
                `Kebijakan Privasi ini mengatur cara Waterfront Sekuritas mengumpulkan, menggunakan, memelihara dan mengungkapkan informasi identitas pribadi yang dikumpulkan dari pengguna (masing-masing, disebut "Pengguna") situs web Waterfront Sekuritas pada www.WaterfrontSekuritas.com ("Situs") termasuk Aplikasi Seluler Waterfront Sekuritas yang terdaftar di App Store dan Google Play Store, atau dikumpulkan melalui layanan jejaring sosial kami (bersama dengan Situs, disebut “Layanan”).`,
                `Dengan mengakses dan/atau menggunakan layanan Waterfront Sekuritas, Pengguna menyatakan bahwa setiap data Pengguna adalah data yang sah, dan Pengguna menyetujui Waterfront Sekuritas untuk memperoleh, mengumpulkan, menyimpan, mengelola dan menggunakan data tersebut sebagaimana tercantum dalam Kebijakan Privasi dan Syarat dan Ketentuan Waterfront Sekuritas.`,
                `Waterfront Sekuritas dari waktu ke waktu berhak memperbarui Kebijakan Privasi ini agar tetap relevan dan terkini dengan perubahan teknologi, hukum yang berlaku, inovasi Waterfront Sekuritas yang terus berkembang dan kebutuhan Pengguna, dan sebaiknya Anda memeriksa halaman ini secara berkala untuk memastikan Anda sudah mengetahui perubahan apapun.`,
                `Waterfront Sekuritas melindungi semua informasi yang diberikan oleh Pengguna ketika Pengguna menggunakan semua Layanan Waterfront Sekuritas.`,
              ],
            },
          ],
        },
        {
          title: "Pengumpulan Informasi",
          description: [
            {
              type: "paragraph",
              content: [
                `Waterfront Sekuritas mengumpulkan data Pengguna dengan tujuan untuk mengelola dan memperlancar proses penggunaan Situs dan/atau Layanan, serta tujuan lainnya selama diizinkan oleh peraturan perundang-undangan yang berlaku. Data Pengguna yang dikumpulkan adalah sebagai berikut:`,
              ],
            },
            {
              type: "list",
              content: {
                title:
                  "Informasi tentang Pengguna, termasuk namun tidak terbatas pada:",
                list: [
                  "Nama",
                  "Nama Alias (jika ada)",
                  "Kebangsaan",
                  "Alamat Sesuai KTP/Passport",
                  "Alamat Lain (jika ada)",
                  "Status pernikahan",
                  "Jenis kelamin",
                  "Nomor telepon pribadi",
                  "E-mail",
                  "Tempat dan tanggal lahir",
                  "Pekerjaan",
                  "Nama ibu kandung",
                  "Nomor KTP",
                  "Pendapatan rata-rata per tahun",
                  "Alamat Kantor (jika ada)",
                  "Sumber dana.",
                  "ID Pemilik Manfaat (jika ada)",
                  "Tujuan pembukaan rekening",
                  "Informasi lain (jika diperlukan)",
                ],
              },
            },
            {
              type: "paragraph",
              content: [
                `Waterfront Sekuritas (PT Waterfront Sekuritas Indonesia) menggunakan vendor pihak ketiga dalam hal penerapan OCR (Optical Character Recognition) pada kartu identitas Pengguna guna mempermudah proses pembukaan rekening. Oleh karena itu Pengguna dengan ini setuju untuk memberikan salinan kartu identitasnya kepada vendor OCR, terbatas untuk tujuan tersebut.`,
              ],
            },
            {
              type: "list",
              content: {
                title:
                  "Data yang disampaikan secara mandiri oleh Pengguna. Pengguna harus menyampaikan data Pengguna yang akurat, termasuk namun tidak terbatas pada data yang disampaikan pada saat Pengguna:",
                list: [
                  "Membuat atau memperbarui rekening Waterfront Sekuritas, termasuk nama pengguna, alamat email, nomor telepon, kata sandi, alamat, foto, dll;",
                  "Menghubungi Waterfront Sekuritas, termasuk melalui layanan pelanggan;",
                  "Berinteraksi dengan pengguna lain melalui perpesanan, streaming diskusi, ulasan, penilaian, dan sebagainya;",
                  "Menggunakan Layanan pada Waterfront Sekuritas, termasuk rincian data transaksi dan/atau tip transaksi pengguna, termasuk jenis, saluran pembayaran yang digunakan, tanggal dan waktu transaksi, serta rincian transaksi lainnya;",
                  "Menggunakan fitur yang memerlukan izin untuk mengakses perangkat Pengguna;",
                  "informasi yang Anda berikan kepada kami selama menggunakan Waterfront Sekuritas (termasuk informasi yang terkandung dalam media apapun yang diunggah untuk dipublikasikan di Situs atau aplikasi kami); dan",
                  "informasi lain apapun yang Anda pilih untuk dikirimkan kepada kami.",
                ],
              },
            },
            {
              type: "list",
              content: {
                title: "Data obtained from other sources, including:",
                list: [
                  "Penyedia layanan pemasaran dan notifikasi;",
                  "Sumber yang tersedia untuk umum.",
                ],
              },
            },
            {
              type: "paragraph",
              content: [
                `Informasi tentang komputer/ponsel Anda dan tentang kunjungan Anda dan penggunaan Waterfront Sekuritas (seperti alamat IP Anda, lokasi geografis, jenis browser, jenis ponsel, sumber rujukan, lama kunjungan dan jumlah tampilan halaman).`,
              ],
            },
          ],
        },
        {
          title: "Penghapusan Rekening",
          description: [
            {
              type: "paragraph",
              content: [
                `Anda dapat meminta untuk menghapus rekening Anda kapan saja. Ketika rekening Waterfront Sekuritas Anda dihapus, maka profil, foto, postingan, dan semua hal lain yang Anda tambahkan akan dihapus. Anda tidak akan dapat mengambil apa pun yang telah Anda tambahkan. Ingatlah bahwa informasi yang dibagikan orang lain tentang Anda bukan bagian dari rekening Anda dan tidak akan dihapus saat Anda menghapus rekening Anda.`,
              ],
            },
            {
              type: "list",
              content: {
                ordered: true,
                list: [
                  "Anda tidak akan dapat mengaktifkan kembali rekening Anda.",
                  "Pengguna dapat menghapus rekening Waterfront Sekuritas dengan mengakses menu: Akun > Profil Akun > Hapus Akun.",
                  "Menghapus rekening Waterfront Sekuritas tidak akan menghapus informasi yang tercantum di mesin pencari termasuk namun tidak terbatas pada Google atau Bing karena Waterfront Sekuritas tidak memiliki kendali atas website tersebut.",
                  "Ketika rekening Waterfront Sekuritas Anda telah dihapus, postingan yang diberi tag oleh pengguna lain di profil Anda akan tetap muncul, namun profil Anda tidak dapat diakses oleh pengguna lain.",
                  "Bila Anda memilih untuk menghapus rekening Anda, kami akan menghapus rekening Anda dari Situs. Beberapa informasi ini dihapus secara permanen dari server kami.",
                  "Beberapa informasi, seperti riwayat pesan, tidak disimpan di rekening Anda. Artinya, teman Anda mungkin masih memiliki akses ke pesan yang Anda kirimkan setelah rekening Anda dihapus.",
                  "Jika Anda ingin menutup rekening perdagangan Anda di PT Waterfront Sekuritas Indonesia, silahkan menghubungi Customer Support kami.",
                  "Pastikan Anda sudah mengosongkan tip jar Anda, karena Waterfront Sekuritas tidak bertanggung jawab atas hilangnya tip yang mungkin masih ada di rekening Anda.",
                  "Alamat email dan nomor telepon Anda tidak dapat digunakan lagi untuk proses pendaftaran selanjutnya.",
                  "Nama pengguna rekening Anda tidak dapat lagi digunakan untuk pendaftaran di Waterfront Sekuritas di kemudian hari.",
                  "Jika rekening Anda sudah terverifikasi atau berstatus Admin, maka ketika profil Anda dihapus maka status tersebut akan diberhentikan.",
                  "Semua aktivitas berlangganan Anda di Waterfront Sekuritas Pro akan hilang setelah penghapusan rekening.",
                  "Salinan beberapa materi mungkin tetap ada di database kami karena Waterfront Sekuritas wajib menyimpan informasi dan data terkait rekening Anda sesuai peraturan OJK yang berlaku.",
                  "Hubungi tim dukungan pelanggan kami untuk meminta penghapusan data permanen dari sistem kami.",
                ],
              },
            },
          ],
        },
        {
          title: "Pilihan Pengguna dan Transaksi",
          description: [
            {
              type: "list",
              content: {
                ordered: true,
                list: [
                  `Perangkat seluler pada umumnya (iOS, Android, dll) memiliki pengaturan sehingga aplikasi Waterfront Sekuritas tidak dapat mengakses data tertentu tanpa persetujuan Pengguna. Perangkat iOS akan memberikan notifikasi kepada Pengguna saat aplikasi Waterfront Sekuritas pertama kali meminta akses data, sedangkan perangkat Android akan memberikan notifikasi kepada Pengguna saat aplikasi Waterfront Sekuritas pertama kali dimuat. Dengan menggunakan aplikasi dan memberikan akses terhadap aplikasi, Pengguna telah mempertimbangkan untuk memberikan persetujuan terhadap Kebijakan Privasi.`,
                  `Pengguna dapat mengakses dan mengubah informasi berupa alamat email, nomor telepon, tanggal lahir, jenis kelamin, foto profil dan informasi lainnya melalui fitur "pengaturan".`,
                  // ⇩⇩⇩ BULLET TAMBAHAN untuk iOS ATT (penambahan saja)
                  `Untuk iOS, apabila fitur pelacakan lintas-aplikasi digunakan, aplikasi akan meminta izin melalui <em>App Tracking Transparency (ATT)</em>. Pengguna dapat menolak atau menonaktifkan kapan saja melalui pengaturan iOS.`,
                ],
              },
            },
          ],
        },
        {
          title: "Nomor dan Kontak Telepon",
          description: [
            {
              type: "paragraph",
              content: [
                `Kami tidak akan pernah memindai atau memasukkan kontak Anda kecuali Anda memintanya. Jika Anda memilih untuk melakukannya, kami hanya akan menggunakan informasi kontak Anda untuk membantu Anda menemukan teman atau kontak yang menggunakan Waterfront Sekuritas.`,
              ],
            },
          ],
        },
        {
          title: "Informasi dan Pengungkapan",
          description: [
            {
              type: "list",
              content: {
                ordered: true,
                title:
                  "Selain pengungkapan yang diperlukan secara wajar untuk tujuan yang disebutkan di bagian lain dalam Kebijakan Privasi ini, kami dapat mengungkapkan informasi tentang Anda:",
                list: [
                  "Sepanjang kami diharuskan melakukannya oleh hukum;",
                  "Sehubungan dengan proses hukum apa pun atau proses hukum yang prospektif (termasuk proses hukum yang direncanakan oleh pihak ketiga, baik terhadap kami, Anda, atau pihak ketiga lainnya);",
                  "Untuk menetapkan, melaksanakan atau membela hak-hak hukum kami (termasuk memberikan informasi kepada orang lain untuk tujuan pencegahan penipuan dan mengurangi risiko kredit); dan",
                  "Kepada pembeli (atau calon pembeli) bisnis atau aset apa pun yang kami (atau rencanakan) jual.",
                ],
              },
            },
          ],
        },
        {
          title: "Dibawah Umur",
          description: [
            {
              type: "paragraph",
              content: [
                `Waterfront Sekuritas hanya tersedia bagi setiap orang yang berusia minimal 17 (tujuh belas) tahun dan/atau yang secara hukum dianggap mampu membuat kontrak yang mengikat.`,
                `Apabila kami mengetahui bahwa kami telah mengumpulkan atau menerima data pribadi dari anak yang berusia di bawah 17 (tujuh belas) tahun tanpa persetujuan orang tua atau wali sah Anda dan/atau anak yang berusia di bawah 13 (tiga belas) tahun, maka kami akan menghapus data pribadi tersebut. Jika Anda yakin kami mungkin memiliki informasi apa pun dari atau tentang anak di bawah 13 (tiga belas) tahun dan/atau anak di bawah 17 (tujuh belas) tahun tanpa izin, silahkan menghubungi kami di Support@waterfrontsekuritas.com.`,
              ],
            },
          ],
        },
        {
          title: "Keamanan",
          description: [
            {
              type: "paragraph",
              content: [
                `Kami akan mengambil tindakan pencegahan yang wajar untuk mencegah kehilangan, penyalahgunaan, atau perubahan informasi pribadi Anda.`,
                `Jika Anda memilih untuk mempublikasikan informasi tentang diri Anda di profil publik Anda atau dalam artikel yang Anda pilih untuk dipublikasikan di Situs (keduanya opsional), informasi ini tentu saja akan tersedia untuk umum di internet.`,
                `Meskipun semua informasi pembayaran dikirim melalui protokol yang aman, transmisi data lainnya melalui internet pada dasarnya tidak aman, dan kami tidak dapat menjamin keamanan data yang dikirim melalui internet.`,
                `Anda bertanggung jawab untuk menjaga kerahasiaan kata sandi dan rincian Pengguna Anda. Kami tidak akan menanyakan kata sandi Anda (kecuali saat Anda login).`,
              ],
            },
          ],
        },
        {
          title: "Layanan dan Situs Web Pihak Ketiga",
          description: [
            {
              type: "paragraph",
              content: [
                `Pengguna mungkin akan menemukan iklan atau konten lain di Situs kami yang menghubungkan tautan ke situs dan layanan mitra, pemasok, pengiklan, sponsor, pemberi lisensi, dan pihak ketiga lainnya. Kami tidak mengontrol konten atau tautan yang muncul di situs-situs ini dan tidak bertanggung jawab atas praktik yang dilakukan oleh situs-situs yang tertaut ke atau dari Situs kami.`,
                `Selain itu, situs atau layanan yang dimaksud di atas, termasuk konten dan tautannya, mungkin akan terus berubah. Situs dan layanan tersebut mungkin memiliki kebijakan privasi dan kebijakan layanan pelanggannya tersendiri. Penjelajahan dan interaksi di situs web lain mana pun, termasuk situs web yang memiliki tautan ke Situs kami tunduk pada syarat dan kebijakan situs web tersebut.`,
                `Waterfront Sekuritas Indonesia juga memiliki kerjasama terkait datafeed dengan Bursa Efek Indonesia (BEI). Data yang didapat dari BEI dan sudah mendapat persetujuan dari BEI untuk ditampilkan pada aplikasi maupun website Waterfront Sekuritas Indonesia.`,
                `Dalam menggunakan layanan pihak ketiga apa pun yang tersedia melalui Layanan, Anda harus setuju untuk mematuhi dan terikat oleh Ketentuan Layanan, Kebijakan Privasi, atau syarat dan ketentuan lain dari penyedia layanan pihak ketiga dan mitra pialang kami. Misalnya, ketika mengakses layanan broker online yang disediakan oleh PT Waterfront Sekuritas Indonesia melalui Layanan, Syarat dan Ketentuan Waterfront Sekuritas Indonesia berlaku untuk semua masalah yang timbul dari penggunaan layanan apa pun yang disediakan kepada Anda melalui Waterfront Sekuritas Indonesia. Syarat dan Ketentuan Waterfront Sekuritas Indonesia tersedia di <a href="https://www.waterfrontsekuritas.com">www.waterfrontsekuritas.com</a>. Oleh karena itu, dengan mengakses Waterfront Sekuritas Indonesia melalui Layanan, Anda mengakui dan menyatakan bahwa Anda telah meninjau dan menerima Syarat dan Ketentuan Waterfront Sekuritas Indonesia.`,
              ],
            },
          ],
        },
        {
          title: "Cookies",
          description: [
            {
              type: "paragraph",
              content: [
                `Cookies adalah file kecil yang secara otomatis akan disimpan di dalam perangkat Pengguna yang menjalankan perangkat dalam bentuk pengelolaan istimewa oleh Pengguna selama berada di Situs.`,
                `Cookie terdiri dari informasi yang dikirim oleh server web ke browser web, dan disimpan oleh browser. Informasi tersebut kemudian dikirim kembali ke server setiap kali browser meminta halaman dari server. Hal ini memungkinkan server web untuk mengidentifikasi dan melacak browser web.`,
                `Cookies ini tidak dimaksudkan untuk digunakan pada saat mengakses data lain yang Pengguna miliki pada perangkat komputer Pengguna, selain dari apa yang telah Pengguna setujui untuk disampaikan.`,
                `Kami dapat menggunakan cookie "sesi" dan cookie "persisten" di situs web. Cookie sesi memungkinkan situs web kami melacak Anda saat Anda menavigasi situs web. Cookies yang persisten akan memungkinkan situs web kami mengenali komputer Anda ketika Anda mengunjungi situs web kami.`,
                `Meskipun cookie sesi akan dihapus dari komputer Anda saat Anda menutup browser, cookie persisten akan tetap tersimpan di komputer Anda hingga dihapus, atau hingga mencapai tanggal kedaluwarsa yang ditentukan.`,
                `Sebagian besar browser mengizinkan Anda menolak menerima cookie. (Misalnya, di Internet Explorer Anda dapat menolak semua cookie dengan mengklik "Alat", "Opsi Internet", "Privasi", dan memilih "Blokir semua cookie" menggunakan pemilih geser.) Namun, hal ini akan berdampak negatif pada kegunaan banyak situs web, termasuk Situs kami.`,
                `Waterfront Sekuritas menggunakan fitur Google Analytics Demographics and Interest. Data yang kami peroleh dari fitur-fitur ini akan digunakan untuk pengembangan Situs dan konten Waterfront Sekuritas. Jika Anda tidak ingin data Anda dilacak oleh Google Analytics, Anda dapat menggunakan Google Analytics Add-On Browser Opt-Out.`,
                `Waterfront Sekuritas dapat menggunakan fitur-fitur yang disediakan oleh pihak ketiga dalam rangka meningkatkan Layanan dan konten Waterfront Sekuritas, termasuk penyesuaian dan penyajian iklan kepada setiap Pengguna berdasarkan minat atau riwayat kunjungan. Jika Anda tidak ingin iklan Anda ditampilkan berdasarkan penyesuaian tersebut, maka Anda dapat mengaturnya melalui browser.`,
              ],
            },
          ],
        },
        {
          title: "Perubahan Kebijakan",
          description: [
            {
              type: "paragraph",
              content: [
                `Waterfront Sekuritas dari waktu ke waktu berhak memperbarui Kebijakan Privasi ini agar tetap relevan dan terkini dengan perubahan teknologi, hukum yang berlaku, inovasi Waterfront Sekuritas yang terus berkembang dan kebutuhan pengguna, dan sebaiknya Anda memeriksa halaman ini sesekali untuk memastikan Anda sudah mengetahui perubahan apa pun.`,
              ],
            },
          ],
        },
        {
          title: "Kontak",
          description: [
            {
              type: "paragraph",
              content: [
                `Jika Anda memiliki pertanyaan tentang Kebijakan Privasi ini, praktik situs ini, atau perihal lainnya yang berkaitan dengan situs ini, silakan hubungi kami di:`,
                `<strong>PT Waterfront Sekuritas Indonesia</strong>`,
                `Head Office`,
                `Sona Topas Tower Lt. 15A, Jl. Jendral Sudirman Kav. 26, RT.4/RW.2, Kuningan, Karet, Kecamatan Setiabudi, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12920`,
                `<a href="mailto:csr@waterfront.co.id">csr@waterfront.co.id</a>`,
                `+6221 250-6355`,
                `+6221 250-6322`,
                `<a href="https://www.waterfrontsekuritas.com">www.waterfrontsekuritas.com</a>`,
              ],
            },
          ],
        },
      ],
    };

    this.headerOffset = 120; // tinggi header tetap kira-kira
    this.scrollEvent = this.scrollEvent.bind(this);
    this.resizeEvent = this.resizeEvent.bind(this);
  }

  toggleToc = () => {
    this.setState((prev) => ({ isTocOpen: !prev.isTocOpen }));
  };

  scrollToSection = (index) => {
    const el = document.getElementById(`privacy-section-${index}`);
    if (!el) return;
    const top =
      el.getBoundingClientRect().top + window.pageYOffset - this.headerOffset;
    window.scrollTo({ top, behavior: "smooth" });
    this.setState({ activeIndex: index });
    if (window.innerWidth <= 768) this.setState({ isTocOpen: false });
  };

  resizeEvent(event) {
    const isMobile = window.innerWidth <= 768;
    this.headerOffset = isMobile ? 100 : 120;
    this.scrollEvent();
  }

  scrollEvent(event) {
    const currentY = window.pageYOffset + this.headerOffset + 5;
    let active = 0;
    for (let i = 0; i < this.state.list.length; i++) {
      const cur = document.getElementById(`privacy-section-${i}`);
      const next = document.getElementById(`privacy-section-${i + 1}`);
      if (!cur) continue;
      const start = cur.offsetTop;
      const end = next ? next.offsetTop : document.body.scrollHeight;
      if (currentY >= start && currentY < end) {
        active = i;
        break;
      }
    }
    if (active !== this.state.activeIndex) {
      this.setState({ activeIndex: active });
    }
  }

  componentDidMount() {
    window.addEventListener("resize", this.resizeEvent);
    window.addEventListener("scroll", this.scrollEvent, { passive: true });

    window.scroll({
      top: 0,
      behavior: "smooth",
    });

    this.resizeEvent(); // init header offset for mobile/desktop
    this.scrollEvent(); // init active
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeEvent);
    window.removeEventListener("scroll", this.scrollEvent);
  }

  render() {
    return (
      <div className="privacy-policy">
        {(this.state.header.title ||
          (this.state.header.description &&
            this.state.header.description.length > 0)) && (
          <div className="privacy-policy-intro">
            {this.state.header.title && <h1>{this.state.header.title}</h1>}
            {this.state.header.description.map((item, index) => (
              <p key={index} dangerouslySetInnerHTML={{ __html: item }}></p>
            ))}
            {this.state.header.meta && (
              <div className="policy-meta" role="group" aria-label="Ringkasan kebijakan">
                {this.state.header.meta.map((m, i) => (
                  <div className="policy-meta__row" key={i}>
                    <span className="policy-meta__label">{m.label}</span>
                    <span className="policy-meta__value">{m.value}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        <div className="privacy-policy-grid">
          {/* Sidebar */}
          <aside
            className={`privacy-policy-sidebar ${
              this.state.isTocOpen ? "is-open" : ""
            }`}
            role="navigation"
            aria-label="Daftar isi kebijakan privasi"
          >
            <button
              type="button"
              className="toc-toggle"
              onClick={this.toggleToc}
              aria-expanded={this.state.isTocOpen}
              aria-controls="privacy-toc"
            >
              Table of Content
            </button>
            <ul id="privacy-toc" aria-hidden={!this.state.isTocOpen}>
              {this.state.list.map((item, index) => (
                <li
                  key={`nav-${index}`}
                  className={
                    index === this.state.activeIndex
                      ? "sidebar-item active"
                      : "sidebar-item"
                  }
                >
                  <button
                    type="button"
                    onClick={() => this.scrollToSection(index)}
                    className="sidebar-button"
                    aria-label={`Loncat ke ${item.title}`}
                  >
                    <span className="sidebar-title">{item.title}</span>
                    <span className="sidebar-caret" aria-hidden>
                      ›
                    </span>
                  </button>
                </li>
              ))}
            </ul>
          </aside>

          {/* Content */}
          <div className="privacy-policy-content">
            <ol>
              {this.state.list.map((item, index) => {
                const isKontak = item.title === "Kontak";
                return (
                  <div
                    key={index}
                    id={`privacy-section-${index}`}
                    className="privacy-policy-content-item"
                  >
                    <li> {item.title} </li>

                    {isKontak ? (
                      <>
                        {item.description &&
                          item.description.length > 0 &&
                          item.description[0].type === "paragraph" && (
                            <p
                              className="contact-intro"
                              dangerouslySetInnerHTML={{
                                __html: item.description[0].content[0],
                              }}
                            />
                          )}
                        <ContactBlock />
                      </>
                    ) : (
                      item.description.map((v, i) => {
                        switch (v.type) {
                          case "paragraph":
                            return <Paragraph key={i} data={v.content} />;
                          case "list":
                            return <List key={i} data={v.content} />;
                          default:
                            return "";
                        }
                      })
                    )}
                  </div>
                );
              })}
            </ol>
          </div>
        </div>
      </div>
    );
  }
}

export default PrivacyPage;